import { Link } from "../../util/router";
import { useAuth } from "../../util/auth";
import PeopleCardEntry from "./PeopleCardEntry";
import { PlusCircleIcon, LinkIcon } from "@heroicons/react/24/outline";

export default function PeopleCard() {
  const auth = useAuth();

  // Get team members directly from user document
  const teamMembers = auth.user?.teamMembers || [];
  const hasMembers = teamMembers.length > 0;

  return (
    <div className="bg-green-50 rounded-lg border-solid border border-green-600">
      <ul className="">
        {hasMembers && (
          <>
            {teamMembers.slice(0, 5).map((memberUid) => (
              <div key={memberUid}>
                <PeopleCardEntry uid={memberUid} />
              </div>
            ))}
          </>
        )}

        {!hasMembers && (
          <div className="flex min-w-0 gap-x-4 p-4 text-center align-center">
            <div className="flex flex-col items-center w-full">
              <p className="text-md font-semibold leading-6 text-gray-900">
                No team members yet
              </p>
              <Link to="/teams/all">
                <button
                  type="button"
                  className="relative flex flex-col items-center rounded-lg border border-dashed border-green-700 p-4 text-center hover:border-green-500 focus:outline-none text-green-700 hover:text-green-500 hover:bg-green-50"
                >
                  <LinkIcon className="h-12 justify-center" />
                  <span className="mt-2 text-sm font-semibold text-gray-900">Invite Team Members</span>
                </button>
              </Link>
            </div>
          </div>
        )}
      </ul>
    </div>
  );
}
